export default "__VITE_ASSET__BSChsOOO__"